export const startAtToPage = (startAt: number, maxResults: number, _total: number) => {
  // const totalPages = (total - (total % maxResults)) / maxResults;
  // console.log('totalPages', totalPages);
  // console.log(' startAt % maxResults', startAt % maxResults);
  return startAt / maxResults + 1;
};

export const totalToNumPages = (maxResults: number, total: number) => {
  const totalPages = (total - (total % maxResults)) / maxResults;
  if (total / maxResults > totalPages) {
    return totalPages + 1;
  }
  return totalPages;
};

export const pageToStartAt = (page: number, maxResults: number) => {
  return (page - 1) * maxResults;
};
